module.exports = __webpack_public_path__ + "img/7.f75d143a.png";